/* TypeScript file generated from Title.resi by genType. */

/* eslint-disable */
/* tslint:disable */

import * as TitleJS from './Title.res.js';

export type alignment = "start" | "center" | "end";

export type fontWeight = "regular" | "medium" | "semibold" | "bold";

export type level = 0 | 1 | 2 | 3 | 4 | 5 | 6;

export type props<children,level,align,weight,italic,color,minChar,wrap> = {
  readonly children: children; 
  readonly level?: level; 
  readonly align?: align; 
  readonly weight?: weight; 
  readonly italic?: italic; 
  readonly color?: color; 
  readonly minChar?: minChar; 
  readonly wrap?: wrap
};

export const make: React.ComponentType<{
  readonly children: React.ReactNode; 
  readonly level?: level; 
  readonly align?: alignment; 
  readonly weight?: fontWeight; 
  readonly italic?: boolean; 
  readonly color?: string; 
  readonly minChar?: number; 
  readonly wrap?: boolean
}> = TitleJS.make as any;
